import { render, staticRenderFns } from "./checkRecords.vue?vue&type=template&id=03981efe&scoped=true"
import script from "./checkRecords.vue?vue&type=script&lang=js"
export * from "./checkRecords.vue?vue&type=script&lang=js"
import style0 from "./checkRecords.vue?vue&type=style&index=0&id=03981efe&prod&lang=less"
import style1 from "./checkRecords.vue?vue&type=style&index=1&id=03981efe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03981efe",
  null
  
)

export default component.exports